import { Box, Flex, Image } from "@chakra-ui/react";
import React from "react";
import { Skeleton, SkeletonCircle, SkeletonText } from "@chakra-ui/react";

const SkeletonCart = () => {
  return (
    <>
      <Box pb={"10px"} borderRadius={"3px"}>
        
        <Flex
          justifyContent={"flex-start"}
          borderTop={"1px solid lightgray"}
          p="10px"
          flexDir="column"
        >
          <Skeleton
            w="95%"
            mr="70px"
            borderRadius={"5px"}
          >
            <Flex
              w="100%"
              justifyContent={"center"}
              alignItems="center"
              h="200px"
              m="auto"
            >
            </Flex>
          </Skeleton>
          <Box mt="20px" mr="20px" w="95%">
            <SkeletonText fontWeight={500}></SkeletonText>
          </Box>
          <Box mt="20px" mr="30px">
            {/* <Text>Item Price</Text> */}
            <SkeletonText> </SkeletonText>
          </Box>
          <Flex mt="20px" mr="30px"></Flex>

          <SkeletonText mt="20px" w="100px" mr="70px"></SkeletonText>
          <Box
          >
            <SkeletonText mt='20px'></SkeletonText>
          </Box>
        </Flex>
      </Box>
    </>
  );
};

export default SkeletonCart;
